import { createSlice } from "@reduxjs/toolkit";

export const uiMenuStatesSlice = createSlice({
    name: "UI_menu",
    initialState: {
        darkTheme: true,
        mainMenuStateOpen: true,
        pedanaMenuStateOpen: true,
        paraventiMenuStateOpen: true,
        ombrelloniMenuStateOpen: true,
        cristalMenuStateOpen: true,
        costoMenuStateOpen: true,
    },
    reducers: {
        handleDarkTheme: (state, action) => {
            state.darkTheme = action.payload;
        },
        handleMainMenu: state => {
            state.mainMenuStateOpen = !state.mainMenuStateOpen;         
        },
        handlePedanaMenu: state => {
            state.pedanaMenuStateOpen = !state.pedanaMenuStateOpen;         
        },
        handleParaventiMenu: state => {        
            state.paraventiMenuStateOpen = !state.paraventiMenuStateOpen;
        },
        handleOmbrelloniMenu: state => {
            state.ombrelloniMenuStateOpen = !state.ombrelloniMenuStateOpen;
        },
        handleCristalMenu: state => {
            state.cristalMenuStateOpen = !state.cristalMenuStateOpen;
        },
        handleCostoMenu: state => {
            state.costoMenuStateOpen = !state.costoMenuStateOpen;
        }
    }
});

export const { handleDarkTheme, handleMainMenu, handlePedanaMenu, handleParaventiMenu, handleOmbrelloniMenu, handleCristalMenu, handleCostoMenu } = uiMenuStatesSlice.actions;

export default uiMenuStatesSlice.reducer;